var map = {
	"./account.svg": "ef22",
	"./components.svg": "e3b6",
	"./logo-head.svg": "fcf5",
	"./logo.svg": "bb69",
	"./mdi-plus.svg": "da7f",
	"./search.svg": "8e8d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";